import classNames from 'classnames'
import React from 'react'


function List({questions = [], onChange = () => {}, activeQuestion, answers}) {
  console.log("🚀 ~ file: List.jsx:6 ~ List ~ answers:", answers)
  if(questions.length == 1){
    return null;
  }
  return (
    <div className='QuestionViewList'>
      {questions.map((_i, index) => <div 
        className={classNames('item', {
          active: _i.id == activeQuestion,
          true: answers[_i.id] ? answers[_i.id].isCorrect : false,
          false: answers[_i.id] ? !answers[_i.id].isCorrect : false,
        })} 
        onClick={() => onChange(_i.id)}
      >#{index + 1}</div>
      )}
    </div>
  )
}

export default List


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionView/components/List/List.jsx